import React from 'react';
import styled from 'styled-components';

const SpinnerBar = () => <SpinnerBarContainer></SpinnerBarContainer>;
const SpinnerBarContainer = styled.div`
  box-sizing: border-box;
  border: 16px solid #f3f3f3;
  border-top: 16px solid #5f5f5f;
  border-radius: 50%;
  width: 100px;
  height: 100px;
  animation: spin 1.4s linear infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export default SpinnerBar;
